import React, { useCallback } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import withImmutablePropsToJS from "with-immutable-props-to-js"

import { oneLine } from "shared/imports/stringFunctions"
import { abSendConfirmationConnection } from "shared/outbox/selectors"
import { Icon, KnobSlider } from "quorumdesign"

import * as S from "app/static/frontend/outbox/components/Alerts/style"
import * as designConstants from "app/static/frontend/design-constants"

const { ABTestMetric, ABTestVariable } = DjangIO.app.userdata.outbox.types

const articleHelper = (abTestVariableValue) => (abTestVariableValue === ABTestVariable.body.value ? "an" : "a")

const ABSendConfirmation = (props) => {
    const FromReplySection = useCallback(
        () => (
            <>
                <div data-cy="ab-test-confirmation-sender">
                    <Icon icon="paper-plane" iconFamily="fas" color={designConstants.QuorumBlue} />
                    {`Sender Name & Email: ${props.fromName} | ${props.fromAddress}`}
                </div>
                <div>
                    <Icon icon="reply" iconFamily="fas" color={designConstants.QuorumBlue} />
                    {`Reply To Name & Email: ${props.replyToName} | ${props.replyToAddress}`}
                </div>
            </>
        ),
        []
    )

    const ABTestedFromSection = useCallback(
        () => (
            <S.ABTestedFromWrapper>
                <Icon icon="paper-plane" iconFamily="fas" color={designConstants.QuorumBlue} />
                <S.VariantFrom data-cy="ab-test-confirmation-sender">
                    {props.abTestVariants.map((variant, index) => (
                        <div>
                            {oneLine`
                            Variation ${String.fromCharCode(65 + index)}:
                            Sender Name & Email:
                            ${variant.from_name} | ${variant.from_address}
                        `}
                        </div>
                    ))}
                </S.VariantFrom>
            </S.ABTestedFromWrapper>
        ),
        []
    )

    return (
        <S.SendConfirmationWrapper>
            <div data-cy="ab-test-confirmation-info">
                <span>
                    You will be running {articleHelper(props.abTestVariable)}{" "}
                    <strong>{ABTestVariable.by_value(props.abTestVariable).label}</strong> test with two variations.
                </span>
            </div>
            <div data-cy="ab-test-confirmation-description">
                <span>
                    <strong>Description:</strong> {props.abTestDescription}
                </span>
            </div>
            <S.Slider>
                <KnobSlider readOnly values={props.abTestDistribution} />
            </S.Slider>
            <div data-cy="ab-test-confirmation-metric">
                <Icon icon="trophy" iconFamily="fas" color={designConstants.QuorumBlue} />
                <span>
                    <span>The winner is determined by </span>
                    <strong>{ABTestMetric.by_value(props.abTestWinCondition).label}</strong>
                </span>
            </div>
            <div>
                <Icon icon="clock" iconFamily="far" color={designConstants.QuorumBlue} />
                <span>
                    Your email is scheduled for <strong>{props.scheduledSendMoment.format("MM/DD/YYYY")}</strong> at{" "}
                    <strong>{props.scheduledSendMoment.format("h:mmA")}</strong>
                </span>
            </div>
            {props.abTestVariable === ABTestVariable.from_address.value ? (
                <ABTestedFromSection />
            ) : (
                <FromReplySection />
            )}
            <div data-cy="ab-test-confirmation-notice">
                <br />
                {oneLine`
                    Please note: you are about to schedule an A/B test which
                    will send two different emails to a randomized group of your recipients.
                `}
            </div>
        </S.SendConfirmationWrapper>
    )
}

ABSendConfirmation.propTypes = {
    abTestDescription: PropTypes.string,
    abTestDistribution: PropTypes.arrayOf(
        PropTypes.objectOf({
            label: PropTypes.string,
            value: PropTypes.number,
        })
    ),
    abTestWinCondition: PropTypes.number.isRequired,
    abTestVariable: PropTypes.number.isRequired,
    abTestVariants: PropTypes.arrayOf(PropTypes.object),
    fromAddress: PropTypes.string.isRequired,
    fromName: PropTypes.string.isRequired,
    isScheduled: PropTypes.bool.isRequired,
    replyToAddress: PropTypes.string.isRequired,
    replyToName: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    scheduledSendMoment: PropTypes.object,
}

export default connect(abSendConfirmationConnection, null)(withImmutablePropsToJS(ABSendConfirmation))
